module.exports = __webpack_public_path__ + "static/media/ki.769e7ca8.svg";